import PageCommon from "../PageCommon.js";
import Pqp from "../../3x1010/Pqp.js";
import Globals from "../../Globals.js";
import ResultViewer from "./results/ResultViewer.js";

export default class PageSolrDetail extends PageCommon {
  constructor() {
    super();
  }

  init($data) {
    super.init($data);
    this.showPreloader(false);
    Pqp.trace("PageSolrDetail - Hello world");

    this.setCssPropsToDoc();
    let resizing;
    window.addEventListener("resize", () => {
      clearTimeout(resizing);
      resizing = setTimeout(() => {
        this.setCssPropsToDoc();
      }, 250);
    });

    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
    } catch (error) {
      // console.log(error);
    }
  }

  get isHomepage() {
    return true;
  }

  doSearch(terms, collection, field = null) {
    const rv = new ResultViewer();
    rv.search(terms, collection, field);
  }

  /**
   * sets offset variables to the container
   * to patch the sticky effect
   * */
  setCssPropsToDoc() {
    const sheet = document.querySelector(".sheet");
    const title = sheet?.querySelector(".sheet-header h1");
    const sectionTitle = sheet?.querySelector(".section-header h2");
    if (!title || !sectionTitle) return;

    sheet?.style.setProperty("--offset", `${sheet?.querySelector('.sheet-header')?.offsetHeight}px`);
  }
}

